import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class TextTimer extends Phaser.GameObjects.Container {
  /**
     * 
     * @param {Phaser.Scene} scene 
     */
  constructor(scene, startSeconds, size, color) {
    super(scene);

    this.startSeconds = startSeconds;
    this.size = size;
    this.color = color;

    this.textLabel = ABCyaPhaser.Text.addText(0, 0, size, color, FontKeys._riffic_freebold, startSeconds, this).setOrigin(0);
  }

  start() {
    this.startTime = this.scene.time.now;
    this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.handleUpdate, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleUpdate, this));
  }

  stop() {
    this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleUpdate, this);
  }

  handleUpdate() {
    this.totalSeconds = Math.floor((this.scene.time.now - this.startTime) / 1000);
    let secondsLeft = this.startSeconds - this.totalSeconds;

    if (secondsLeft <= 0) {
      secondsLeft = 0;
      this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleUpdate, this);
      this.emit('TIMER_DONE');
    }

    this.textLabel.text = `${secondsLeft}`;
  }
}